import type { CustReqApplySubmitItem, CustReqShareTarget } from '../../types/custReqShare.types';

// 반장 작업보고 작성 화면의 고객 요청 반영(S16) 순수 로직 — 기획 941 S16-10, 확정결정 17, K1 3.4·3.8.

export const CUST_REQ_APPLY_MESSAGE = {
  title: '고객 요청',
  guide: '작업보고 쓸 때 반영한 요청을 체크해 주세요',
  applied: '반영했어요',
  requestPhoto: '고객 사진',
} as const;

/** 요청별 [반영했어요] 체크 상태 — 키는 custReqId, 값이 없으면 체크하지 않은 것 */
export type ApplyChecks = Readonly<Record<number, boolean | undefined>>;

/** 영역 헤더 문구 — '고객 요청 n건' */
export function sectionTitle(count: number): string {
  return `${CUST_REQ_APPLY_MESSAGE.title} ${count}건`;
}

/** 체크하지 않은 요청 수 */
export function uncheckedCount(targets: readonly Pick<CustReqShareTarget, 'custReqId'>[], checks: ApplyChecks): number {
  return targets.filter((t) => checks[t.custReqId] !== true).length;
}

/** '작업완료' 선택 시 미체크 안내 — 제출은 막지 않는 한 줄. 안내할 것이 없으면 null */
export function doneHintText(isDone: boolean, unchecked: number): string | null {
  if (!isDone || unchecked <= 0) return null;
  return `고객 요청 ${unchecked}건이 체크되지 않았어요. 아래 고객 요청에서 체크해 주세요.`;
}

/** 제출에 함께 보낼 반영 입력 — 화면에 보인 대상 전부(체크 안 한 건은 applied=false) */
export function buildSubmitItems(targets: readonly Pick<CustReqShareTarget, 'custReqId'>[], checks: ApplyChecks): CustReqApplySubmitItem[] {
  return targets.map((t) => ({ custReqId: t.custReqId, applied: checks[t.custReqId] === true }));
}
